import script from "./ClientsStatsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsStatsSection.vue?vue&type=script&setup=true&lang=js"

import "./ClientsStatsSection.vue?vue&type=style&index=0&id=600a2404&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600a2404"]])

export default __exports__